import { integrations } from "@/data/integrations";
import { Link } from "react-router-dom";

export default function Integrations() {
  const cats = [...new Set(integrations.map((i) => i.category))];
  return (
    <div data-testid="page-integrations">
      <section className="py-20 md:py-28 hero-grid-bg">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#00A651] mb-4">Integrations</div>
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tighter text-[#1F1E4E] leading-[1.05]">
            Plays nicely with your entire stack.
          </h1>
          <p className="mt-5 text-lg text-slate-600">Native integrations with the tools your team already uses — plus a modern REST API for the rest.</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6 space-y-14">
          {cats.map((cat) => (
            <div key={cat}>
              <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#00A651] mb-5">{cat}</div>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {integrations.filter((i) => i.category === cat).map((i) => (
                  <div key={i.name} className="bg-white rounded-2xl border border-slate-200 p-6 hover:-translate-y-1 hover:shadow-md transition-all">
                    <div className="h-10 w-10 rounded-xl bg-[#1F1E4E] flex items-center justify-center text-white font-extrabold text-sm">
                      {i.name.charAt(0)}
                    </div>
                    <div className="mt-4 text-lg font-extrabold text-[#1F1E4E]">{i.name}</div>
                    <div className="text-sm text-slate-500 mt-1">{i.desc}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h3 className="text-2xl md:text-3xl font-extrabold text-[#1F1E4E]">Don't see your tool?</h3>
          <p className="mt-3 text-slate-600">We build custom integrations to any REST-based system.</p>
          <Link to="/contact?intent=contact_sales" data-testid="integrations-cta" className="inline-flex mt-6 bg-[#00A651] hover:bg-[#008A43] text-white font-bold rounded-lg px-6 py-3">
            Request an Integration
          </Link>
        </div>
      </section>
    </div>
  );
}
